
import Vue, { defineComponent } from 'vue';

import BaseButton from './BaseButton.vue';
import BaseFormField from './BaseFormField.vue';
import BaseFormInput from './BaseFormInput.vue';
import PasswordRequirements from './PasswordRequirements.vue';

export default defineComponent({
  name: 'PasswordInput',
  components: {
    BaseFormField,
    BaseFormInput,
    PasswordRequirements,
    BaseButton
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: () => Vue.t('utils:PasswordInput.createNewPassword')
    },
    showErrors: {
      type: Boolean,
      default: false
    },
    error: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      inputType: 'password'
    };
  },
  computed: {
    password: {
      get(): string {
        return this.value;
      },
      set(value: string) {
        this.$emit('input', value);
      }
    },

    allRequirementsMet(): boolean {
      return (
        this.password.length >= 8 &&
        /[A-Z]/.test(this.password) &&
        /\d/.test(this.password) &&
        /[a-z]/.test(this.password)
      );
    }
  },

  watch: {
    allRequirementsMet() {
      this.$emit('update:is-valid', this.allRequirementsMet);
    }
  },
  methods: {
    togglePassword() {
      this.inputType = this.inputType === 'password' ? 'text' : 'password';
    }
  }
});
